export function Icon({ name, size = 18, className }) {
  const p = {
    users:
      "M16 11c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 3-1.34 3-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm8 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5C19 14.17 14.33 13 12 13zm-8 0C1.67 13 0 14.17 0 16.5V19h6v-2.5C6 14.17 3.33 13 2 13z",
    cart: "M7 18a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm10 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM7.16 14h8.59c.66 0 1.24-.43 1.43-1.06l2.12-6.94A1 1 0 0 0 18.34 5H5.21L4.27 2H1v2h2l3.6 9.59-.95 2.28c-.39 1.08.23 1.71 1 1.71H19v-2H7.42l.74-1.74z",
    tx: "M12 2v4l3-3-3-1zM12 22v-4l-3 3 3 1zM2 12h4l-3-3-1 3zm20 0h-4l3 3 1-3zM4.93 5.64l2.83 2.83.71-3.54-3.54.71zM19.07 18.36l-2.83-2.83-.71 3.54 3.54-.71z",
    report:
      "M14 2H6a2 2 0 0 0-2 2v16l5-2 5 2V4a2 2 0 0 0-2-2zm2 0h2a2 2 0 0 1 2 2v14h-2V4h-2V2zM8 6h6v2H8V6zm0 4h6v2H8v-2z",
    list: "M3 6h14v2H3V6zm0 5h14v2H3v-2zm0 5h14v2H3v-2z",
    plus: "M11 3h2v8h8v2h-8v8h-2v-8H3v-2h8z",
    customer:
      "M12 12a4 4 0 1 0-4-4 4 4 0 0 0 4 4zm0 2c-3 0-9 1.5-9 4.5V21h18v-2.5C21 15.5 15 14 12 14z",
    truck:
      "M20 8h-3V5H3v11h2a3 3 0 0 0 6 0h4a3 3 0 0 0 6 0h2v-4l-3-4zM7 19a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm10 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm3-6h-3V9h1l2 3v1z",
    caret: "M7 10l5 5 5-5z",
    bell: "M12 22a2 2 0 0 0 2-2H10a2 2 0 0 0 2 2zm6-6V11a6 6 0 1 0-12 0v5l-2 2v1h16v-1l-2-2z",
    sun: "M6.76 4.84l-1.8-1.79L3.17 4.84l1.79 1.8 1.8-1.8zM1 13h3v-2H1v2zm10 10h2v-3h-2v3zm8.83-18.16l-1.79-1.79-1.8 1.79 1.8 1.8 1.79-1.8zM20 11v2h3v-2h-3zm-8-8h2V0h-2v3zm-7.07 14.95l1.79 1.79 1.8-1.79-1.8-1.8-1.79 1.8zM16.24 19.16l1.8 1.79 1.79-1.79-1.79-1.8-1.8 1.8z",
    moon: "M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z",
  };
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path fill="currentColor" d={p[name] || p.list} />
    </svg>
  );
}
